import EventEmitter from 'eventemitter3';

export const loaderEvent = 'LOADER_EVENT';
export interface ILoaderEvent {
    loading: boolean;
    message: string;
}

// May be complex to convert this as an interface
// tslint:disable-next-line:interface-over-type-literal
type LoaderEventsMap = {
    [loaderEvent]: (event: ILoaderEvent) => void;
};

export interface ILoaderService {
    showLoader(message?: string): void;
    hideLoader(): void;
    getLoading(): boolean;
    eventEmitter(): EventEmitter<LoaderEventsMap>;
}

export default class LoaderService implements ILoaderService {
    static serviceInstance: ILoaderService;
    private readonly emitter: EventEmitter<LoaderEventsMap>;
    private loading = false;
    private message: string = '';

    static getInstance(): ILoaderService {

        if (!this.serviceInstance) {
            this.serviceInstance = new LoaderService();
        }

        return this.serviceInstance;
    }

    constructor() {
        this.emitter = new EventEmitter();
    }

    showLoader(message: string = ''): void {
        this.loading = true;
        this.message = message;
        this.broadcast();
    }

    hideLoader(): void {
        this.loading = false;
        this.message = '';
        this.broadcast();
    }

    getLoading(): boolean {
        return this.loading;
    }

    eventEmitter(): EventEmitter<LoaderEventsMap> {
        return this.emitter;
    }

    private broadcast() {
        const event: ILoaderEvent = {
            loading: this.loading,
            message: this.message
        };

        this.emitter.emit(loaderEvent, event);
    }
}



// WEBPACK FOOTER //
// ./src/services/LoaderService.ts